import Chips from "./chips.component.js";

export default angular
    .module("oui.chips", [])
    .component("ouiChips", Chips)
    .name;
